import styled from "@emotion/styled";
import { colors, spacing } from "../../constants";

export const ErrorContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;

  background: linear-gradient(
    135deg,
    ${colors.gradientStart},
    ${colors.gradientEnd}
  );
  color: ${colors.neutralDark};

  transition: background-color 0.25s ease-out;
`;

export const Title = styled.h1`
  margin-bottom: ${spacing.marginMedium};
  font-size: 4rem;
  color: ${colors.primaryWhite};
`;
